import React, { useState, useEffect, useMemo } from 'react';
import { useAppData } from './context/DataContext';
import { getEventLoc, processLocations } from './information.service.js'
import EventCard from './EventCard';
import OrgCard from './OrgCard';
import { Link } from "react-router-dom";
import Navbar from './Navbar';
import Footer from './Footer';
import FilterPanel from './FilterPanel';
import { ReactComponent as NoEvents } from './NoEvents.svg';
import OrganizerNavbar from './OrganizerNavbar';
import axios from 'axios';

// const recurring = ["N/A", "Daily", "Weekly", "Monthly"];
// const age = ["N/A", "Youth", "HS/College", "Adult"];
// const gender = ["N/A", "Male", "Female"];
// const organizer = ["N/A", "Masjid", "Community"];
// const price = ["N/A", "Free", "$", "$$", "$$$"];

function createCard(info, organizations, organizationsLoading, findMatchingOrg) {

  if (info.event_id == "6852") {
    console.log(info.timeArray)
  }
  
  // Find matching organization for this event
  const matchedOrg = findMatchingOrg(info.organization, organizations);
  
  return (
    <Link key={info.event_id} to={`/event/${info.event_id}`} className="card-link">
      <EventCard
        imgurl={info.img}
        event={info.name}
        masjid={info.organization}
        matchedOrg={matchedOrg}
        organizationsLoading={organizationsLoading}
        date={info.timeArray[0]}

        altdate={info.dateIndex === -1 ? info.dates[0] : info.dates[info.dateIndex]}
        time={info.start_time}

        description={info.description}
        age={info.age_range}
        frequency={info.frequency}
        price={info.price}
        gender={info.gender}
        registered={info.registered}

        tags={info.tags}

      />
    </Link>
  );
}

function Events() {

  const {
    information,
    informationWithPastEvents,
    loggedInUser,
  } = useAppData();

  // Add organization state and fetching
  const [organizations, setOrganizations] = useState([]);
  const [organizationsLoading, setOrganizationsLoading] = useState(true);

  const secrets = require("./secrets.js");
  const api = secrets.server_url;

  // Function to fetch all organizations
  async function getAllOrganizations() {
    try {
      const response = await axios.get(`${api}organizations/`, {
        headers: {
          "x-api-key": process.env.REACT_APP_UMMAHFY_API_KEY,
        },
      });
      if (response && response.data && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error("Error fetching organizations:", error);
      return [];
    }
  }

  // Function to find matching organization by name
  function findMatchingOrg(orgName, orgsList) {
    if (!orgName || !orgsList || orgsList.length === 0) return null;
    
    return orgsList.find(org => 
      org.name && org.name.toLowerCase() === orgName.toLowerCase()
    ) || null;
  }

  // Fetch organizations once on component mount
  useEffect(() => {
    async function fetchOrganizations() {
      try {
        setOrganizationsLoading(true);
        const orgsData = await getAllOrganizations();
        setOrganizations(orgsData);
        setOrganizationsLoading(false);
      } catch (error) {
        console.error("Error fetching organizations:", error);
        setOrganizationsLoading(false);
      }
    }

    fetchOrganizations();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const eventsPerPage = Number.MAX_SAFE_INTEGER; // Number of events to display per page
  //console.log(eventsPerPage, "max number")
  const [filters, setFilters] = useState({
    organizer: {
      masjid: false,
      community: false
    },
    age: {
      youth: false,
      hsCollege: false,
      adult: false
    },
    gender: {
      male: false,
      female: false
    },
    recurring: {
      daily: false,
      weekly: false,
      monthly: false
    },
    price: {
      free: false,
      paid: false
    },
    date: null,
    distance: null,
    search: "",
    location: ""
  });

  const [filteredInfo, setFilteredInfo] = useState(information);

  useEffect(() => {
    const fetchFilteredInfo = async () => {
      const result = await handleFiltering();
      setFilteredInfo(result);
      if (result.length === 0) {
        setCurrentPage(1);
      }
    };
    fetchFilteredInfo();
  }, [filters, information]);

  async function handleFiltering() {
    const scoredEvents = [];
    const infoToFilter = JSON.parse(JSON.stringify(information));
    // console.log(filters.location)
    if (filters.location) {
      const newUserLoc = await getEventLoc(filters.location);
      await processLocations(infoToFilter, newUserLoc.latitude, newUserLoc.longitude);
      // console.log('PROCESSING LOCS!!!!')
    }
    // console.log("[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[")
    // infoToFilter.forEach(item => {
    //   console.log(item.name)
    //   console.log(item.distanceFromUser)
    //   console.log("----------------")
    // })

    infoToFilter.forEach(item => {
      let isMatch = true;
      let score = 0;

      if (filters.distance && filters.distance !== 0 && !item.location) {
        isMatch = false;
      }

      for (const key in filters) {
        const filterOptions = filters[key];

        if (key === 'location') {
          continue;
        }

        if (key === 'search') {
          if (filterOptions && !(item.name.toLowerCase().includes(filterOptions.toLowerCase()) || item.organization.toLowerCase().includes(filterOptions.toLowerCase()))) {
            isMatch = false;
            break;
          }
          continue;
        }

        if (key === 'date') {
          if (filterOptions) {
            const filterDate = new Date(filterOptions);
            filterDate.setHours(0, 0, 0, 0);
            
            // Get event date based on dateIndex
            const eventDate = new Date(item.dateIndex === -1 ? item.start_datetime : item.dates[item.dateIndex]);
            eventDate.setHours(0, 0, 0, 0);
            
            // First check if event is already past using our improved logic
            if (item.past) {
              isMatch = false;
              break;
            }
            
            // Then check if event date is before the filter date
            if (eventDate < filterDate) {
              isMatch = false;
              break;
            }
          }
          continue;
        }

        if (key === 'distance') {
          if (filterOptions && item.distanceFromUser > filterOptions) {
            isMatch = false;
            break;
          }
          continue;
        }

        const activeFilters = Object.keys(filterOptions).filter(option => filterOptions[option]);
        if (activeFilters.length > 0) {
          const lowerCaseActiveFilters = activeFilters.map(option => option.toLowerCase());
          const itemValue = (item[key] || "").toLowerCase();

          if (key === 'price') {
            if (filterOptions.paid && filterOptions.free) {
              break;
            } else if (filterOptions.paid && (itemValue === 'free' || itemValue === '0')) {
              isMatch = false;
              break;
            } else if (filterOptions.free && itemValue !== 'free' && itemValue !== '0') {
              isMatch = false;
              break;
            }
          } else if (itemValue === 'all') {
            continue;
          } else if (!lowerCaseActiveFilters.includes(itemValue)) {
            isMatch = false;
            break;
          } else {
            score++;
          }
        }
      }

      if (isMatch) {
        scoredEvents.push({ item, score });
      }
    });

    scoredEvents.sort((a, b) => b.score - a.score);
    return scoredEvents.map(event => event.item);
  }


  const indexOfLastEvent = currentPage * eventsPerPage;
  const indexOfFirstEvent = indexOfLastEvent - eventsPerPage;
  const currentEvents = filteredInfo.slice(indexOfFirstEvent, indexOfLastEvent);

  // Build the set of organization names that have at least one event in
  // the platform's events array. Scraped events typically reference orgs
  // that don't have a record in `organizations`, so the intersection of
  // (orgs in DB) ∩ (orgs that host events) yields the real, registered
  // orgs we want to surface.
  const eventOrgNames = useMemo(() => {
    const allEvents = informationWithPastEvents || information || [];
    const set = new Set();
    allEvents.forEach((evt) => {
      if (evt?.organization) {
        set.add(evt.organization.toLowerCase());
      }
    });
    return set;
  }, [informationWithPastEvents, information]);

  const qualifyingOrgs = useMemo(() => {
    if (!Array.isArray(organizations) || organizations.length === 0) return [];
    const hasPicture = (org) =>
      typeof org?.profilePicture === "string" &&
      org.profilePicture.trim().length > 0;
    return organizations
      .filter((org) => org?.name && eventOrgNames.has(org.name.toLowerCase()))
      .sort((a, b) => {
        // Orgs with a profile picture come first; then alphabetical within
        // each group so the order is stable and predictable.
        const aPic = hasPicture(a) ? 0 : 1;
        const bPic = hasPicture(b) ? 0 : 1;
        if (aPic !== bPic) return aPic - bPic;
        return a.name.localeCompare(b.name);
      });
  }, [organizations, eventOrgNames]);

  // Apply the same search term used for events so typing filters both lists.
  const visibleOrgs = useMemo(() => {
    const term = (filters.search || "").trim().toLowerCase();
    if (!term) return qualifyingOrgs;
    return qualifyingOrgs.filter((org) =>
      org.name.toLowerCase().includes(term)
    );
  }, [qualifyingOrgs, filters.search]);

  // const handleChange = (date) => {
  //   console.log('Selected date:', date);
  // };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //console.log("information array", information)

  return (
    <div>
      {/* {console.log("this is the information array", information)} */}
      <div className="wrapper">
        <Navbar />
        <div className="filter-calendar">
          <div className="grid-filter">
            <FilterPanel setFilters={setFilters} />
          </div>


          <div className="grid-eventcards">
            {visibleOrgs.length > 0 && (
              <section className="org-row-section" aria-label="Organizations">
                <div className="org-row-header">
                  <h2 className="org-row-title">Organizations</h2>
                  <span className="org-row-count">
                    {visibleOrgs.length}
                  </span>
                </div>
                <div className="org-row-scroller">
                  {visibleOrgs.map((org) => (
                    <OrgCard key={org._id || org.name} org={org} />
                  ))}
                </div>
              </section>
            )}

            <div className="header-pagination">
              <h1 className="event-header">Upcoming Events</h1>
            </div>

            {/* <div className="pagination top-pagination">
                {currentPage > 1 && (
                  <button className="pagbtn prev-btn" onClick={() => paginate(currentPage - 1)}>Previous</button>
                )}
                {currentEvents.length > 0 && currentPage < Math.ceil(filteredInfo.length / eventsPerPage) && (
                  <button className="pagbtn next-btn" onClick={() => paginate(currentPage + 1)}>Next</button>
                )}
              </div> */}

            {currentEvents.map(info => createCard(info, organizations, organizationsLoading, findMatchingOrg))}
            {currentEvents.length === 0 && (
              <>
                <div class="no-events-div">
                  {/* <img src={noEventsImage} alt="No events" style={{ width: '100%' }} /> */}
                  <NoEvents className="no-events-svg" />
                </div>
              </>
            )}
          </div>
        </div>
        {/* <div className="pagination">
          {currentPage > 1 && (
            <button className="pagbtn prev-btn" onClick={() => paginate(currentPage - 1)}>Previous</button>
          )}
          {currentEvents.length > 0 && currentPage < Math.ceil(filteredInfo.length / eventsPerPage) && (
            <button className="pagbtn next-btn" onClick={() => paginate(currentPage + 1)}>Next</button>
          )}
        </div> */}
      </div>
      <Footer />
    </div>
  );
}

export default Events;
